export default {
	data() {
		return {
			renderedOptions: []
		}
	},
	watch: {
		// Blijft het component bestaan terwijl :options een nieuwe lijst krijgt (bv. een
		// formulier in een modal die opnieuw gebruikt wordt), dan zou het bij alleen
		// mounted() met de oude opties blijven staan. De aangevinkte waarden worden
		// tegen deze lijst vergeleken, dus leek de selectie dan leeg.
		options(options) {
			if (this.ajaxUrl) {
				return;
			}

			this.renderedOptions = options ?? [];
		}
	},
	methods: {
		// Opties zijn {id, text}; het oudere {value, label} blijft ondersteund, net als in het Select veld
		optionValue(option) {
			return option.id ?? option.value;
		},

		optionLabel(option) {
			return option.text ?? option.label;
		},

		async getOptionsFromAjaxUrl() {
			let result = await new Promise((resolve) => {
				Helpers.Ajax.get(this.ajaxUrl, {
					FieldList: 'id,text',
					pagination: 0,
				}, {
					afterSuccess: (response) => resolve(response.results),
					afterError: () => resolve([])
				});
			});
			return result;
		}
	},
	async mounted() {
		if(this.ajaxUrl) {
			this.renderedOptions = await this.getOptionsFromAjaxUrl()
		} else {
			this.renderedOptions = this.options;
		}
	},
}